<script setup lang="ts">
import { useMobile } from '@/composables/useMobile';

// Tab bar that survives crowded mobile screens: on phones the tabs collapse to
// a single select (dropdown) to pick the section; from `sm` up it renders the
// usual scrollable tab bar. The parent keeps owning the v-window content.
//   <responsive-tabs v-model="tab" :items="tabItems" />
export interface ResponsiveTabItem {
  value: string;
  title: string;
  icon?: string;
}

defineProps<{ items: ResponsiveTabItem[] }>();
const model = defineModel<string>({ required: true });

const { isPhone } = useMobile();
</script>
<template>
  <v-select
    v-if="isPhone"
    v-model="model"
    :items="items"
    item-title="title"
    item-value="value"
    variant="outlined"
    density="comfortable"
    hide-details
    class="ma-2"
  >
    <template #selection="{ item }">
      <v-icon
        v-if="item.raw.icon"
        :icon="item.raw.icon"
        start
        size="small"
      />
      {{ item.title }}
    </template>
    <template #item="{ item, props: itemProps }">
      <v-list-item
        v-bind="itemProps"
        :title="item.title"
        :prepend-icon="item.raw.icon"
      />
    </template>
  </v-select>
  <v-tabs
    v-else
    v-model="model"
    color="primary"
    density="comfortable"
    show-arrows
  >
    <v-tab
      v-for="item in items"
      :key="item.value"
      :value="item.value"
    >
      <v-icon
        v-if="item.icon"
        :icon="item.icon"
        start
      />
      {{ item.title }}
    </v-tab>
  </v-tabs>
</template>
